import { useLanguage } from "../../contexts/LanguageContext";

function RemoveUser({ isOpen, closeModal, confirmRemove }) {
  const { t } = useLanguage();
  const handleOutsideClick = (e) => {
    if (e.target.id === "removeUserModal") closeModal();
  };

  if (!isOpen) return null;

  return (
    <div
      id="removeUserModal"
      onClick={handleOutsideClick}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(6px)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: '80px', zIndex: 50 }}
    >
      <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border-glass)', borderRadius: '20px', padding: '28px', width: '380px', maxWidth: '90vw', position: 'relative' }}>
        <div style={{ height: '3px', position: 'absolute', top: 0, left: 0, right: 0, borderRadius: '20px 20px 0 0', background: 'linear-gradient(90deg, #f87171, #ef4444)' }} />
        <div style={{ textAlign: 'center', marginTop: '8px' }}>
          <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: 'rgba(248,113,113,0.1)', border: '1px solid rgba(248,113,113,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px', fontSize: '1.4rem' }}>⚠️</div>
          <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: 'var(--text-primary)', fontFamily: 'var(--font-display)', marginBottom: '8px' }}>{t('confirmUserRemoval')}</h3>
          <p style={{ fontSize: '0.85rem', color: 'var(--text-muted)', marginBottom: '20px', lineHeight: 1.5 }}>
            {t('removeUserWarning')}
          </p>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
            <button onClick={closeModal} style={{ padding: '10px 24px', borderRadius: '10px', border: '1px solid var(--border-glass)', background: 'var(--bg-elevated)', color: 'var(--text-secondary)', fontWeight: 600, cursor: 'pointer', fontSize: '0.85rem' }}>{t('cancel')}</button>
            <button onClick={confirmRemove} style={{ padding: '10px 24px', borderRadius: '10px', border: 'none', background: 'linear-gradient(135deg, #f87171, #ef4444)', color: '#fff', fontWeight: 600, cursor: 'pointer', fontSize: '0.85rem' }}>{t('confirm')}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RemoveUser;

